import { useContext } from "react";
import { FormControl, InputAdornment } from "@mui/material"
import InputTheme from "../../generic/input"
import { LangContext } from "../../../contexts/LangContext"
import React from 'react';


export default function InputNameGroup({errorText, ...props }) {
    const { lang } = useContext(LangContext)

    return (
        <FormControl sx={{ width: '100%',variant:"standard",
        borderColor: '#274598',borderRadius: '9px', }} >
            <InputTheme error={props.error} helperText={errorText ? "" : errorText} label={lang.components.generic.input_name_group_label} id="standard-adornment-name-group" variant="standard" endAdornment={
                <InputAdornment position="end" sx={{ padding: '8px' }}>
                </InputAdornment>
            } {...props} />
        </FormControl>
    )
}